import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ChangeOrderStatusService } from '@http/clients/reporting-app/change-order-status.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-change-order-status-form-editor',
    templateUrl: './report-change-order-status-form-editor.component.html',
    styleUrls: ['./report-change-order-status-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportChangeOrderStatusFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportChangeOrderStatusFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Change Order Status');
    placeholderText = input<string>('Select Change Order Status');

    private readonly changeOrderStatusService = inject(ChangeOrderStatusService);

    async ngOnInit(): Promise<void> {
        const statuses = await this.changeOrderStatusService.getAll();
        this.items.set(statuses);
    }

    override writeValue(value: number[] | null): void {
        this.selectedValue.set(value ?? undefined);
        if (!value?.length) {
            this.selectedItems.set([]);
            return;
        }
        this.selectedItems.set(this.mapValueToSelectedItems(value));
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
